<ng-template [ngIf]="hasSelectedOrder()">
	<shoppingcart-header-mobile-component (viewShoppingcartClickEvent)="viewShoppingcart()"
	                                      (viewOrderDetailClickEvent)="viewOrderDetail()">
	</shoppingcart-header-mobile-component>
</ng-template>